export const CONFIRMATIONAPROVAL = 'CONFIRMATIONAPROVAL';
export const STATUSJOB = 'STATUSJOB';
export const FORMALIZATIONOBJ = 'FORMALIZATIONOBJ';
export const TASACIONOBJ = 'TASACIONOBJ';
export const MOTIVOCIERRE = 'MOTIVOCIERRE';
